import styled from 'styled-components'

export const Grid = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;
  align-content: stretch;
  flex-wrap: wrap;
  & > div {
    width: ${props => props.cardWidth};
    min-height: ${props => props.cardHeight};
  }
`

export const GridItem = styled.div`
  padding: 8px;
  display: flex;
`
export const TitleGroup = styled.div`
  padding-left: 8px;
  margin: 30px 0;
`
export const Title = styled.h1`
  font-weight: 500;
  font-size: 22px;
  line-height: 33px;
  color: #2e2e37;
  margin: 0;
`
export const VehiclesSavedText = styled.div`
  font-weight: 500;
  color: #696977;
  font-size: 14px;
`
